export default [
  {
    title: '考核日期',
    key: 'reportTime',
    width: 68
  },
  {
    title: '姓名',
    key: 'name'
  },
  {
    title: '游戏组',
    key: 'gameName',
    width: 100
  },
  {
    title: '游戏',
    key: 'gameNameReal',
    width: 140
  },
  {
    title: '媒体',
    key: 'mediaName'
  },
  {
    title: '实际消耗金额',
    key: 'amount',
    width: 92
  },
  {
    title: '30日角色流水金额',
    key: 'thirtyNewRoleMoney',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日激活流水金额',
    key: 'thirtyNewDeviceMoney',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日创角(账号)流水金额',
    key: 'thirtyCreateRoleMoney',
    sortable: 'custom',
    width: 110
  },
  {
    title: 'CP分成扣点',
    key: 'cpRate',
    width: 62
  },
  {
    title: '30日角色流水分成后金额',
    key: 'thirtySynthesizeMoney',
    width: 110
  },
  {
    title: '30日激活流水分成后金额',
    key: 'thirtySynthesizeDeviceMoney',
    width: 110
  },
  {
    title: '30日创角(账号)分成后金额',
    key: 'thirtySynthesizeCreateRoleMoney',
    width: 120
  },
  {
    title: '30日角色回款率',
    key: 'thirtySynthesizeRetain',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日激活回款率',
    key: 'thirtySynthesizeDeviceRetain',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日创角(账号)回款率',
    key: 'thirtySynthesizeCreateRoleRetain',
    sortable: 'custom',
    width: 110
  },
  {
    title: '类型',
    key: 'remark',
    width: 80
  }
]
